import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ExperimentCreationModel, CeLogistics } from '../../shared/services/request.service';
import { ViewableRequest } from '../review-request/review-request.model';
import { Aoi } from '../../shared/services/aoi.service';
import { FacilityType } from '../../shared/services/facility-type.service';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorsService } from '../../shared/services/validators.service';
import { PlanningInformation } from '../../shared/services/planning.service';

@Component({
  selector: 'app-create-experiment-modal',
  templateUrl: './create-experiment-modal.component.html'
})
export class CreateExperimentModalComponent implements OnInit {

  public request: ViewableRequest;
  public ceLogistics: CeLogistics;
  public planningNotes: PlanningInformation;
  public facilities: FacilityType[] = [];
  public aois: Aoi[] = [];
  public minPlantDate = new Date();
  public plannedAOILocation:string;

  public createExperimentForm: FormGroup;
  public get actualPlantDate() { return this.createExperimentForm.get('actualPlantDate') };
  public get facility() { return this.createExperimentForm.get('facility') };
  public get prismExperimentName() { return this.createExperimentForm.get('prismExperimentName') };
  public get aoi () { return this.createExperimentForm.get('aoi') };
 
  public onClose: Subject<any> = new Subject<any>();
  public onCreateExperiment: Subject<ExperimentCreationModel> = new Subject<ExperimentCreationModel>();

  constructor(formBuilder: FormBuilder, public bsModalRef: BsModalRef, validatorsService: ValidatorsService) { 
    this.createExperimentForm = formBuilder.group({
      facility: formBuilder.control(null, [Validators.required]),
      prismExperimentName: formBuilder.control(null, [Validators.required]),
      aoi: formBuilder.control(null, Validators.required),      
      actualPlantDate: formBuilder.control({ value: null, disabled: false }, [
        Validators.required, validatorsService.mustBeOnOrAfterDate(this.minPlantDate), validatorsService.isValidDate])
    });
  }

  ngOnInit() {
      this.createExperimentForm.setValue({ 
        facility: null,
        aoi: null,       
        prismExperimentName: this.request.requestNumber,
        actualPlantDate: this.ceLogistics.plannedPlantingDate
      });
     this.plannedAOILocation =this.planningNotes.plannedAoiLocation;
  }

  public close(): void {
    this.onClose.next();
  }

  public createExperiment(): void {
    const formValue = this.createExperimentForm.value as ExperimentCreationFormModel;
    this.onCreateExperiment.next(
      {
        id: this.request.id,
        facilityId: formValue.facility,
        prismExperimentName: formValue.prismExperimentName,
        aoiId: formValue.aoi.prismId,
        aoiName: formValue.aoi.name,
        actualPlantDate: formValue.actualPlantDate,
        trialManagerID: formValue.aoi.id
      });
  }
}

interface ExperimentCreationFormModel {
  facility: number;
  prismExperimentName: string;
  aoi: Aoi;
  actualPlantDate: Date;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/create-experiment-modal/create-experiment-modal.component.ts